import React, { FC } from 'react';

import { ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

export const LearnMoreAboutJITApprovals: FC = () => {
  const list = ['Cloud type', 'Account', 'Data group', 'Access duration'];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="jit_approvals"
      headerTitle="JIT Approvals"
      body={
        <Stack spacing={10}>
          <Text>
            Just in Time or JIT is a framework that eliminates long standing
            permissions to cloud and data. As part of this framework, Ariksa
            provides controls for granular enforcement of permissions that are
            limited by scope and time that drastically reduce the identity
            related risks and attack surface area due to excess or unauthorized
            permissions to users and non-human identities.
          </Text>
          <Text>
            Ariksa also provides a robust framework for approvals for just in
            time access by users in your organization. You can define granular
            approval policies based on your organizational policies that can be
            automated to reduce manual intervention so that security can work at
            the speed for the business and for developers, data analysts, data
            scientists, IT, SRE, DevOps and others often require cloud and data
            permissions to get their work done.
          </Text>

          <Stack spacing={2}>
            <Text>
              Ariksa approval policies can be customized intuitively for
              easy-to-understand but granular controls that automate approvals
              based on
            </Text>
            <UnorderedList spacing={2}>
              {list.map(item => (
                <ListItem pl={4} key={item}>{item}</ListItem>
              ))}
            </UnorderedList>
          </Stack>
        </Stack>
      }
    />
  );
};
